import {CLIENT_PROMO_CODES} from './siteIds'

const config = {
  clientId: CLIENT_PROMO_CODES,
  clientUrl: 'https://www.promocodes.com/',
  appName: 'Promocodes',
  siteName: 'Promocodes.com',
  price: 24.99,
  currency: 'USD',
  currencySymbol: '$',
  primaryColor: 'lime',
  outlineFocusColor: 'focus:outline-lime-600',
  bgColor: 'bg-lime-600',
  hoverColor: 'bg-lime-600',
  focusVisibleColor: `focus-visible:outline-lime-600`,

  brands: [
    {name: 'wayfair', logo: '/popular-brands/wayfair-coupons.png'},
    {name: 'alibris', logo: '/popular-brands/alibris-coupons.png'},
    {name: 'dell', logo: '/popular-brands/dell-coupons.png'},
    {
      name: 'the body shop',
      logo: '/popular-brands/the-body-shop-coupons.png',
    },
    {name: 'chewy', logo: '/popular-brands/chewy-coupons.png'},
    {name: 'gopro', logo: '/popular-brands/gopro-coupons.png'},
    {name: 'norton', logo: '/popular-brands/norton-coupons.png'},
    {name: 'michael kors', logo: '/popular-brands/michael-kors-coupons.png'},
  ],
}
export default config
